var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('span',{staticClass:"icon",style:(_vm.getStyle),on:{"click":function($event){return _vm.scrollToTop()}}},[_c('i',{class:_vm.getIcon})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }